// extracted by mini-css-extract-plugin
export default {"submitBtn":"SubmitButton_submitBtn__+eMLJ"};